/**
 * Pide llevar YA al celular las etiquetas de una conversación (19-oct-2026).
 *
 * La base anota cada cambio de etiquetas (trigger de `wa_conversations.tags`, migración 20261019090000), venga de donde
 * venga, y wa-eventos-worker lo lleva cada minuto. Esto sólo lo adelanta: se llama DESPUÉS de guardar, para que el
 * celular lo muestre en segundos. Si se olvida en algún lugar, igual llega en la próxima vuelta del worker.
 * El servidor decide si escribe: sólo en líneas cuyo motor declara `etiquetas.escribir` (el conector propio).
 */
import { supabase } from '@/lib/supabase';

export function llevarLasEtiquetasAlCelular(conversationId: string): void {
  void supabase.functions.invoke('whatsapp-send-message', { body: { action: 'llevar_etiquetas', conversation_id: conversationId } })
    .catch(() => undefined); // el worker la lleva en la próxima vuelta
}

/** 19-oct · Pide llevar YA al celular el nombre y el color de una etiqueta de WhatsApp editada en Smarty (si no, la
 *  lleva wa-eventos-worker en el minuto). El servidor compara con el celular y escribe sólo lo que cambió. */
export function llevarLaEtiquetaEditada(tagId: string): void {
  void supabase.functions.invoke('whatsapp-send-message', { body: { action: 'llevar_etiqueta_editada', tag_id: tagId } })
    .catch(() => undefined);
}

// 20-oct · Las etiquetas de un chat se guardan con `cambiarLasEtiquetas` (lib/whatsapp/cambiarLasEtiquetas.ts): la
// diferencia, sobre lo que hay en la base. Guardar la lista entera perdía clics seguidos.

/** 21-oct · Que una etiqueta de Smarty exista en el celular de cada línea del negocio (fn_wa_etiqueta_va_a_los_celulares,
 *  20261021083100): en el que no la tiene se crea, o se empareja si ya tiene una con ese nombre. Y se pide ya. */
export async function llevarALosCelulares(tagId: string): Promise<boolean> {
  const { error } = await supabase.rpc('fn_wa_etiqueta_va_a_los_celulares', { p_tag: tagId });
  if (!error) llevarLaEtiquetaEditada(tagId);
  return !error;
}

/** 21-oct · Borra una etiqueta de Smarty y la anota para borrarla en los celulares que la tienen (fn_wa_borrar_etiqueta):
 *  devuelve en cuántos celulares, o null si no se pudo. Y lo pide ya. */
export async function borrarLaEtiqueta(tagId: string, tenantId: string): Promise<number | null> {
  const { data, error } = await supabase.rpc('fn_wa_borrar_etiqueta', { p_tag: tagId });
  if (error) return null;
  const celulares = typeof data === 'number' ? data : 0;
  if (celulares > 0) {
    void supabase.functions.invoke('whatsapp-send-message', { body: { action: 'llevar_etiquetas_borradas', tenant_id: tenantId } })
      .catch(() => undefined); // el worker las lleva en la próxima vuelta
  }
  return celulares;
}

/** 21-oct · Pide llevar YA a los celulares el orden de las etiquetas que se acaban de reordenar en Smarty (si no, lo lleva
 *  wa-eventos-worker en el minuto: el trigger de `wa_tags.sort_order` lo anota, 20261021091700). */
export function llevarElOrdenAlCelular(tenantId: string): void {
  void supabase.functions.invoke('whatsapp-send-message', { body: { action: 'llevar_el_orden', tenant_id: tenantId } })
    .catch(() => undefined);
}
